<template>
    <div>
        <div class="home">
            <div class="logo-wrapper pt-4 pb-4">
                <img src="/img/logo.png" alt="kapitani.bg logo" class="logo">
            </div>

            <div
                v-for="course in courses"
                v-bind:key="course.id"
                class="btn-list-wrapper"
                @click="navigate(course.id)"
                style="cursor: pointer"
            >
                <div class="container">
                    {{ course.title }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import courses from '../../data/courses';

    export default {
        data() {
            return {
                courses: courses,
            }
        },
        methods: {
            navigate(courseId) {
                this.$router.push({
                    name: 'course',
                    params: {
                        course: courseId,
                    }
                })
            },
        }
    }
</script>